import { useState, useEffect } from 'react';

import { RoleTypes } from 'interfaces';

type usePermissionTypes = {
  canAccessBo: boolean;
  setCanAccessBo: (value: boolean) => void;
};

export const usePermissions = (
  userRoles: RoleTypes[] | undefined,
): usePermissionTypes => {
  const [canAccessBo, setCanAccessBo] = useState(false);

  useEffect(() => {
    const hasPermissions = userRoles?.find(
      (role: RoleTypes): boolean => role.permissions.length > 0,
    );
    if (hasPermissions) {
      setCanAccessBo(true);
    }
  }, [userRoles]); // eslint-disable-line react-hooks/exhaustive-deps

  return { canAccessBo, setCanAccessBo };
};
